import { render, staticRenderFns } from "./uiobs3Texto.vue?vue&type=template&id=4b66b291"
import script from "./uiobs3Texto.vue?vue&type=script&lang=js"
export * from "./uiobs3Texto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports